const T = require('prop-types');
const CsvUploadField = require('components/CsvUploadField');

module.exports = function FormFileField(props) {

    const {
        field = {},
        helperText,
        onBlur,
        onChange,
        onFocus,
        setValue,
        value
    } = props;

    const handleChange = (nextValue, event) => {

        if (typeof setValue === 'function') {
            setValue(nextValue, event);
        }

        if (typeof onChange === 'function') {
            onChange(nextValue, event);
        }
    };

    return <CsvUploadField
        accept={field.accept}
        contextLabel={field.contextLabel}
        description={field.description}
        disabled={!!field.disabled}
        emptyLabel={field.label || 'Click to Select a File'}
        error={props.error}
        helperText={helperText}
        inputProps={field.inputProps}
        minHeight={field.minHeight}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        showActionButton={!!field.showActionButton}
        value={value}
    />;
};

module.exports.propTypes = {
    error: T.oneOfType([T.bool, T.object]),
    field: T.object,
    helperText: T.string,
    onBlur: T.func,
    onChange: T.func,
    onFocus: T.func,
    setValue: T.func,
    value: T.any
};
